import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { DataSource } from '@angular/cdk/collections';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/debounceTime';


import { OpcionModel } from '../Global/Opcion.model';
import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import { MatSnackBar } from '@angular/material';


@Component({
	selector: 'habilitarEnvioFacturas',
	templateUrl: './HabilitarEnvioFacturas.component.html',
	styleUrls: ['../../../../styles.css']
})

/**
* @author Camilo
* @since  26/10/2017
**/
export class HabilitarEnvioFacturasComponent {

	public form: FormGroup;
	public formErrors: any;


	public listaPatrimonios: Array<OpcionModel>;
	public listaPrefijos: Array<string>;

	public cnumcont: OpcionModel;
	public ciddoc: string = '';
	public cnumdoc: string = '';
	public cargando: boolean = false;

	public ocultar: boolean = false;
	public mensaje: string = "";

	myControl = new FormControl();
	filteredOptions: Observable<OpcionModel[]>;


	// ~~~~~ Variables para el manejo de permisos ~~~~~ //
	public btnAgregar: boolean;
	public btnEditar: boolean;
	public btnEliminar: boolean;
	public btnConsultar: boolean;
	// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //


	constructor(private formBuilder: FormBuilder, private _serviciosGenerales: ServiciosGenerales, public snackBar: MatSnackBar,
		private _route: ActivatedRoute, private _router: Router, public dialog: MatDialog) {

		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.btnAgregar = _serviciosGenerales.seguridad.isAgregar();
		this.btnEditar = _serviciosGenerales.seguridad.isEditar();
		this.btnEliminar = _serviciosGenerales.seguridad.isEliminar();
		this.btnConsultar = _serviciosGenerales.seguridad.isConsultar();
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.snackBar.dismiss();
	}


	ngOnInit() {

		this.listaPatrimonios = new Array();

		this.cargarInfo();


		this.filteredOptions = this.myControl.valueChanges
			.startWith(null)
			.map(val => val ? this.filter(val) : this.listaPatrimonios.slice());


		this.inicializarForm();

		this.cargarComponentesFormulario();

		this.cnumcont = new OpcionModel('', "");

	}

	cargarComponentesFormulario() {

		this.listaPrefijos = new Array();

	}


	inicializarForm() {
		this.formErrors = {
			cnumcont: {},
			ciddoc: {},
			cnumdoc: {}
		};


		this.form = this.formBuilder.group({
			cnumcont: ['', Validators.required],
			ciddoc: ['', Validators.required],
			cnumdoc: ['', Validators.required]
		});
	}






	private cargarInfo() {

		this._serviciosGenerales.get('listaPatrimonios', { param: 0 }).subscribe(
			result => {
				for (let x of result) {
					this.listaPatrimonios.push(new OpcionModel(x.cnumcont, x.vnombrenegocio));
				}
			},
			error => {
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar los patrimonios", "X");
			});


	}


	consultarPrefijos() {
		this.listaPrefijos = new Array();
		this._serviciosGenerales.get('listaPrefijos', { cnumcont: this.cnumcont.labelOpcion.split('-')[0].trim() }).subscribe(
			result => {
				for (let x of result) {
					this.listaPrefijos.push(x.cprefijo);
				}

			},
			error => {
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar los prefijos", "X");
			});
	}



	guardar() {
		if (this.form.valid == false) {
			this.openSnackBarEspecial("Todos loa campos son requeridos", "X");
		} else {
			console.log("Va a enviar...");
			this._serviciosGenerales.post('habilitarEnvioFacturas', { cnumcont: this.cnumcont.labelOpcion.split('-')[0].trim(), ciddoc: this.ciddoc, cnumdoc: this.cnumdoc }).subscribe(
				result => {

					this.openSnackBar(result.mensaje, "X");

				}, error => {
					this.openSnackBarEspecial("Ocurrió un error mientras se habilita la factura para el envío", "X");
					console.log(error);
				});
		}
	}

	filter(val: string)//: string[]
	{
		if (val == null) {
			val = "";
		}


		let x = this.listaPatrimonios.filter(option => (option.idOpcion.toLowerCase().trim() + option.labelOpcion.toLowerCase().trim()).indexOf(val.toLowerCase()) > -1);

		return x;

	}

	onFormValuesChanged() {
		for (const field in this.formErrors) {
			if (!this.formErrors.hasOwnProperty(field)) {
				continue;
			}

			// Clear previous errors
			this.formErrors[field] = {};

			// Get the control
			const control = this.form.get(field);

			if (control && control.dirty && !control.valid) {
				this.formErrors[field] = control.errors;
			}
		}
	}

	openSnackBar(message: string, action: string) {
		this.snackBar.open(message, action, {
			duration: 20000
		});
	}


	openSnackBarEspecial(message: string, action: string) {
		let snackBarRef = this.snackBar.open(message, action);

		snackBarRef.onAction().subscribe(() => {
			console.log("Paso por aqui 1 notas");

			this.ocultar = false;
			this.mensaje = "";
		});

		let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;

		if (shand.length != 0) {
			for (let i = 0; i < shand.length; i++) {
				shand[i].style.backgroundColor = "rgb(255 204 214)";
			}
		}
	}


}









// WEBPACK FOOTER //
// D:/REPO/FacturacionWeb/src/app/main/content/HabilitarEnvioFacturas/HabilitarEnvioFacturas.component.ts